import { AxiosError, AxiosRequestConfig } from 'axios'

import { logger } from '@/sdk/oauth'

export default async (
  error: AxiosError,
): Promise<AxiosRequestConfig | AxiosError> => {
  logger(
    'userRequest -> response interceptor failed with request -> %O',
    error.config,
  )

  return Promise.reject(error)
}
